import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Popover } from 'primeng/popover';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        Popover
    ],
    exports: [
        CommonModule,
        Popover
    ],
    providers: []
})
export class PrimrngModule { }
